// --- Blindaje contra crashes por traducción del navegador --------------------
// Los traductores del navegador (Safari Translate en iOS, Google Translate)
// reemplazan cada TextNode de la página por un <font> con la traducción. React
// mantiene referencias a los nodos ORIGINALES; cuando reconcilia y llama
// removeChild/insertBefore sobre un nodo que el traductor ya movió/envolvió, el
// navegador tira un NotFoundError —en Safari el texto es "The object can not be
// found here"— y se cae toda la vista (lo cazamos como [CHUNK] PANTALLA, pero el
// origen es la traducción, no un chunk).
//
// Es un bug del navegador SIN fix upstream: Chromium #872770 está abierto desde
// 2018 y afecta a React 16–19 por igual (la reconciliación no cambió). No existe
// librería madura; el estándar de facto es este patch defensivo de Dan Abramov
// (React core, github.com/facebook/react/issues/11538).
//
// Qué hace: si el nodo NO es hijo de quien se lo pide (lo movió el traductor),
// devuelve el nodo en vez de lanzar. Cuando SÍ es hijo (el caso normal, ~todo),
// delega 1:1 en el método nativo → los removeChild/insertBefore legítimos de
// React funcionan idénticos. Debe instalarse ANTES del primer render.
export function installDomTranslateGuard(): void {
  if (typeof Node !== 'function' || !Node.prototype) return;
  const proto = Node.prototype as Node & { __agoraTranslateGuard?: boolean };
  if (proto.__agoraTranslateGuard) return; // idempotente
  proto.__agoraTranslateGuard = true;

  let warned = false;
  const warnOnce = (op: string) => {
    if (warned) return;
    warned = true;
    // Aviso UNA sola vez (el traductor genera muchas mutaciones): suficiente para
    // saber que el guard actuó sin inundar la consola del vendor.
    console.warn(
      `[agora] DOM translate guard: ${op} sobre un nodo ajeno (probable traductor del navegador). Se suprime para no crashear React.`
    );
  };

  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function <T extends Node>(this: Node, child: T): T {
    if (child.parentNode !== this) {
      warnOnce('removeChild');
      return child;
    }
    return originalRemoveChild.call(this, child) as T;
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function <T extends Node>(
    this: Node,
    newNode: T,
    referenceNode: Node | null
  ): T {
    if (referenceNode && referenceNode.parentNode !== this) {
      warnOnce('insertBefore');
      return newNode;
    }
    return originalInsertBefore.call(this, newNode, referenceNode) as T;
  };
}
